import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './inicio/inicio.component';
import { DiretoriaInternacionalComponent } from './diretoria-internacional/diretoria-internacional.component';
import { DiretoriaNacionalComponent } from './diretoria-nacional/diretoria-nacional.component';
import { NadhmiComponent } from './nadhmi/nadhmi.component';
import { FinancaComponent } from './financa/financa.component';
import { ImoveisComponent } from './imoveis/imoveis.component';
import { HotelComponent } from './hotel/hotel.component';
import { MarketingComponent } from './marketing/marketing.component';
import { FarmaceuticaComponent } from './farmaceutica/farmaceutica.component';
import { GmhAlimentosComponent } from './gmh-alimentos/gmh-alimentos.component';
import { GmhHospitalidadeComponent } from './gmh-hospitalidade/gmh-hospitalidade.component';
import { TrabalheConoscoComponent } from './trabalhe-conosco/trabalhe-conosco.component';
import { ProjetosBrasilComponent } from './projetos-brasil/projetos-brasil.component';
import { FaleConoscoComponent } from './fale-conosco/fale-conosco.component';

import { PostsComponent } from './posts/posts.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {path: '', component: InicioComponent},
  {path: 'diretoria-internacional', component: DiretoriaInternacionalComponent},
  {path: 'diretoria-nacional', component: DiretoriaNacionalComponent},
  {path: 'nadhmi', component: NadhmiComponent},
  {path: 'financa', component: FinancaComponent},
  {path: 'imoveis', component: ImoveisComponent},
  {path: 'hotel', component: HotelComponent},
  {path: 'marketing', component: MarketingComponent},
  {path: 'farmaceutica', component: FarmaceuticaComponent},
  {path: 'gmhalimentos', component: GmhAlimentosComponent},
  {path: 'gmhhospitalidade', component: GmhHospitalidadeComponent},
  {path: 'trabalheconosco', component: TrabalheConoscoComponent},
  {path: 'projetos-brasil', component: ProjetosBrasilComponent},
  {path: 'faleconosco', component: FaleConoscoComponent},
  {path: 'login', component: LoginComponent},
  {path: 'noticias', component: PostsComponent}

]
@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes)
  ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts